export const environment = {
  production: true,
  apiBase: 'http://cashadvance-api.ark.ph'
};
